import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type { SsntEntry, SsntState } from './types';

const initialState: SsntState = {
  reports: {},
};

const ssntSlice = createAppSlice({
  name: 'ssnt',
  initialState,
  reducers: {
    // One writer for every outcome. `SsntEntry` is a discriminated union, so the
    // type system already guarantees a `showReport` entry carries a report and no
    // other status does — separate per-status reducers would add surface area
    // without adding a guarantee.
    //
    // Writing the entry is also what flips the per-child "has loaded" signal
    // (`makeSelectSsntHasLoaded`), atomically and in the same tick as the data —
    // Rule 7. Overwrites are expected: each page open refetches its child.
    setSsntEntry: (
      state,
      action: PayloadAction<{ childId: string; entry: SsntEntry }>,
    ) => {
      state.reports[action.payload.childId] = action.payload.entry;
    },
  },
});

export const { setSsntEntry } = ssntSlice.actions;
export default ssntSlice.reducer;
